<template>
  <div>
    <header-bar>
      著作権スプリット
    </header-bar>
    <div class="page-block">
      <div class="page-block__inner">
        <div class="confirm-split-items">
          <div>
            <p class="content-info">内容確認</p>
            <p class="content-info">あなたの著作権スプリット情報</p>
          </div>
          <div
            class="info-container">
            <span class="form-title">
              この作品の管理者は{{ owner }}です。
            </span>
            <p>作品名：{{ item.copyrights.title_ja }} </p>
            <p>分配率：{{ formattedRate(item.rate) }}%</p>
            <p>役割：{{ mapRoles(item.role) }} </p>
          </div>
          <div>
            <div
              class="release-caution-area u-no-margin-top guest-caution-area">
              <div class="release-caution-area__title">【ご注意】</div>
              <div class="release-caution-area__paragraph">
                <ul class="c-indent-list">
                  <li
                    class="c-indent-list__node">
                    私は、本サービスに関する<a
                      class="c-text-link"
                      target="_blank"
                      href="https://narasu.jp/client/static/copyright-terms">規約</a>に同意のうえ、届出申請をします。
                  </li>
                  <li
                    class="c-indent-list__node">
                    私は、<a
                      class="c-text-link"
                      target="_blank"
                      href="https://narasu.jp/client/static/copyright-assignment-terms">音楽著作権の期間及び限定譲渡に関する規約</a>に同意のうえ、届出申請をします。
                  </li>
                  <li
                    class="c-indent-list__node">
                    私は、本作品に関し、届出申請をする上で正当な権利を保持しています。
                  </li>
                  <li
                    class="c-indent-list__node">
                    私は、未成年ではありません。または保護者の同意を得ました。
                  </li>
                  <li
                    class="c-indent-list__node">
                    届出申請後は著作者情報を変更することができません。
                  </li>
                  <li
                    class="c-indent-list__node">
                    著作権譲渡期間は5年間となり、更新タイミング以外での管理停止は原則承っておりません。
                  </li>
                  <li
                    class="c-indent-list__node">
                    生成AIを用いて制作された作品の場合、本サービスをご利用いただくことはできません。
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="confirm-checkbox-area guest-approve-checkbox-area">
              <div class="checkbox">
                <label>
                  <input
                    v-model="confirmed"
                    type="checkbox">
                  <div class="option-input"></div>
                  注意事項を確認しました
                </label>
              </div>
            </div>
            <div
              class="release-caution-area u-no-margin-top
                checkbox-list guest-approve-checkbox-area">
              <div class="release-caution-area__title">
                【著作権管理サービスについて】
              </div>
              私は、著作権登録サービスを利用する楽曲は、以下の全ての項目に該当しないことを確認しました。<br />
              <p class="border-checkbox-item">
                チェックボックス内にチェックをお入れください。
              </p>
              <div
                v-for="(label, checkboxIndex) in copyrightRegistrationServiceItemLabel"
                :key="checkboxIndex"
                class="checkbox m-right-0">
                <label
                  class="checkbox-list-label">
                  <input
                    v-model="copyrightRegistrationServiceItemsValue[checkboxIndex]"
                    type="checkbox">
                  <div class="option-input"></div>
                  <div>
                    {{ label }}
                  </div>
                </label>
              </div>
              <span>「ご自身の作品が登録済みか確認する方法」は<a
                class="c-text-link mt-30"
                target="_blank"
                href="https://www2.jasrac.or.jp/eJwid/">こちら</a>（JWID）</span>
            </div>
          </div>
        </div>
        <div class="c-btn-wrap">
          <button
            :class="{ 'c-btn--off' : !confirmed || !allCopyrightRegistrationServiceItemChecked }"
            class="c-btn"
            name="submit"
            type="button"
            @click.prevent="confirmCopyrightSplit()">
            承認する<span class="c-btn__icon-arrow" />
          </button>
          <button
            class="c-btn c-btn--back c-btn--back-left"
            @click.prevent="cancelledCopyrightSplit()">
            <span>キャンセル</span>
          </button>
        </div>
      </div>
    </div>
    <confirm-dialog
      name="cancelCopyrightSplit"
      :is-shown="confirmDialog"
      title="著作権スプリットをキャンセルしますか？"
      :is-hover-on-default-button="true"
      @closed="onCancelClicked()"
      @default-clicked="onDefaultClicked()"
      @cancel-clicked="onCancelClicked()">
      <template #body>
        あなたがキャンセルした場合、<br>
        著作権スプリットは開始されません。
      </template>
    </confirm-dialog>
  </div>
</template>

<script>
import HeaderBar from '../../HeaderBar'
import ConfirmDialog from '../../../../components/ConfirmDialog'

export default {
  name: 'ConfirmAppliedCopyrightSplit',
  components: {
    HeaderBar,
    ConfirmDialog,
  },
  data() {
    return {
      item: {
        copyrights: {
          title_ja: '',
        },
        role: '',
      },
      confirmDialog: false,
      owner: '',
      splitId: '',
      confirmed: false,
      copyrightRegistrationServiceItemLabel: [
        'AIによって自律的に自動生成し、作詞または作曲された作品',
        '著作権管理団体へ登録済の楽曲／narasu以外からの著作権登録中または登録済み',
        '登録済みの楽曲のアレンジ違い・バージョン違い',
        '第三者が権利を有する曲をサンプリング使用した楽曲',
        '環境音やノイズのみの楽曲',
        'オリジナルでない楽曲（バージョン項目に表記がある楽曲）',
      ],
      copyrightRegistrationServiceItemsValue: [false, false, false, false, false, false],
    }
  },
  computed: {
    allCopyrightRegistrationServiceItemChecked() {
      return this.copyrightRegistrationServiceItemsValue.every(item => item === true)
    },
  },
  async mounted() {
    const { splitId } = JSON.parse(window.sessionStorage.getItem('copyright-split')) || {}
    this.splitId = splitId
    if (splitId) {
      await this.getCopyrightSplitById(splitId)
    }
  },
  methods: {
    async getCopyrightSplitById(id) {
      try {
        const { data } = await window.axios.get(`/api/client/copyrights/split/${id}`)
        this.item = data.splits
        this.owner = data.email
      } catch (err) {
        window.location.href = '/client'
      }
    },
    cancelledCopyrightSplit() {
      this.confirmDialog = true
    },
    async confirmCopyrightSplit() {
      const response = await window.axios.post('/api/client/copyrights/split/approve', {
        id: this.splitId,
      })
      if (response.status === 200) {
        await this.$router.push({ path: '/client/copyright-split/approval-completed' })
      }
    },
    async onDefaultClicked() {
      const response = await window.axios.post('/api/client/copyrights/split/cancel', {
        id: this.splitId,
      })
      if (response.data && response.status === 200) {
        this.confirmDialog = false
        await this.$router.push({ path: '/client/copyright-split/cancelled' })
      }
    },
    onCancelClicked() {
      this.confirmDialog = false
    },
    mapRoles(roles) {
      const mapping = {
        lyricist: '作詞',
        composer: '作曲',
        'co-lyricist': '補作詞者',
        'co-composer': '補作曲者',
      }
      return roles.split(',').map(key => mapping[key]).toString()
    },
    formattedRate(rate) {
      if (!rate) return ''

      return rate !== 100 ? parseFloat(rate).toFixed(1) : '100'
    },
  },
}
</script>

<style scoped>
.content-info {
  font-size: 24px;
  margin:auto;
  text-align: center;
}
.info-container{
  text-align: start;
  margin: auto;
  width: fit-content;
  padding: 14px 0;
}
.form-title {
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
}
.confirm-split-items {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.guest-caution-area {
  margin-left: 55px;
  background-color: #fff;
}
.guest-approve-checkbox-area {
  margin-left:55px;
}

.border-checkbox-item {
  border-bottom: 2px dotted black;
  padding-bottom: 8px;
  margin-bottom: 8px;
}
.checkbox-list {
  display: flex;
  flex-direction: column;
  background: none;
}
.checkbox-list-label {
  font-weight: normal;
  max-width: 550px;
}
.m-right-0{
  margin-right: 0;
}
.mt-30 {
  margin-top: 30px;
}
@media screen and (max-width: 895px) {
  .checkbox-list-label {
    line-height: 38px !important;
  }
}
</style>
